export class PlayerProfileField {
    constructor(json?: any) {
        this.id = json && json.id || null;
        this.weighting = json && json.weighting || null;
        this.code = json && json.code || null;
        this.description = json && json.description || null;
    }

    id: number;
    weighting: number;
    code: string;
    description: string;
}